import React from "react";

/**
 * Reusable field info tooltip (same markup/classes as CalculatorHeader renderTooltip).
 * Shows nothing if `info` is empty.
 */
const FieldInfoTooltip = ({ info, className = "", iconSize = 16 }) => {
  if (!info) return null;

  return (
    <span className={`field tooltip-p ${className}`.trim()}>
      <img
        src="/assets/InfoIcon.svg"
        alt="Info"
        height={iconSize}
        width={iconSize}
      />
      <span className="tooltiptext p-2">{info}</span>
    </span>
  );
};

export default FieldInfoTooltip;

